import Vue from 'vue'

import { type FlagIdentity, type Flags, evaluateFlags } from '@/helpers/ConfigCat'

const flagStore = new Vue({ data: { current: {} as Flags } })

/** Reactive flags for the active identity. Read `flags.my_flag` anywhere. */
export const flags: Flags = flagStore.$data.current

/** Recomputes `flags` in place, preserving the shared reactive reference. */
export function syncFlags(identity?: FlagIdentity): void {
  const next = evaluateFlags(identity)

  for (const key of new Set([...Object.keys(flags), ...Object.keys(next)]) as Set<keyof Flags>) {
    if (key in next) Vue.set(flags, key, next[key])
    else Vue.delete(flags, key)
  }
}
